<div class="alert alert-success" *ngIf="messages">
    <h4 class="alert-heading title">
        <mat-icon>done</mat-icon>
        {{header}}
    </h4>
    <ul class="error-list" *ngIf="messages.length > 1">
        <li *ngFor="let message of messages">{{message}}</li>
    </ul>
    <p *ngIf="messages.length == 1">{{messages[0]}}</p>
</div>
